import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { DepartmentsDialogComponent } from '../../Dialogs/departments-dialog/departments-dialog.component';
import { Department, User, LogDTO, LogType } from 'BaseDataTypes';
import { UserService } from 'BaseServices/user-service';
import {
  ListViewComponent,
  listRow,
  getExtraBurgerMenuOptions,
  MenuOption,
} from '@standard-angular-utilities/shared-components';
import { FormsModule } from '@angular/forms';
import { DepartmentService } from 'TrainingTrackingServices/department-service';
import { CourseEventLogService } from 'TrainingTrackingServices/course-event-log-service';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { SharedFunctionsService } from 'BaseServices/sharedFunctions.service';
import { LogService } from 'BaseServices/log-service';
import { LogHelperService } from 'BaseServices/log-helper.service';

@Component({
  selector: 'app-departmens-view',
  templateUrl: './departmens-view.component.html',
  styleUrls: ['./departmens-view.component.css'],
  imports: [ListViewComponent, FormsModule, MatButtonModule],
})
export class DepartmensViewComponent implements OnInit {
  @ViewChild('listView') listView!: ListViewComponent<Department>;
  @ViewChild('logListView') logListView!: ListViewComponent<LogDTO>;

  onChangeFunction: () => void = () => {};

  readonly dialog = inject(MatDialog);

  departmentHeaderList: string[] = ['Navn'];
  headerList: string[] = this.departmentHeaderList;
  departments: Department[] = [];
  logHeaderList: string[];
  isHistory: boolean = false;
  users: User[] = [];

  currentUser = this.userService.currentUser;

  extraBurgerMenuOptions: MenuOption[] = [];

  constructor(
    private DepartmentService: DepartmentService,
    private userService: UserService,
    private logService: LogService,
    private logHelper: LogHelperService
  ) {
    this.logHeaderList = this.logService.getLogHeaders('Afdeling');
  }

  ngOnInit() {
    const isAdmin =
      this.userService.getSelectedRole ===
      this.userService.getUserRoleTypes.Admin;
    const customLabel = 'Skift til afdelinger';

    this.extraBurgerMenuOptions = getExtraBurgerMenuOptions(
      isAdmin,
      this.isHistory,
      customLabel,
      this.switchDataInList.bind(this),
      () => this.extraBurgerMenuOptions[0][0],
      (newLabel: string) => {
        this.extraBurgerMenuOptions[0][0] = newLabel;
      }
    );
  }

  ngAfterViewInit(): void {
    this.updateListWithDepartmentData();
    this.getAllUsers();
  }

  createNewDepartment() {
    let defaultDepartment: Department = {
      id: 0,
      departmentNumber: 0,
      departmentName: '',
      displayName: '',
    };
    let dialogref = this.dialog.open(DepartmentsDialogComponent, {
      data: { data: [defaultDepartment] },
    });
    dialogref.afterClosed().subscribe((result) => {
      if (result == true) {
        this.updateListWithDepartmentData();
      }
    });
  }

  getAdminNameFromUserId(id: number): string {
    return (
      this.users.find((user) => user.id === id)?.name || 'Bruger ikke fundet'
    );
  }

  getDepartmentNameFromId(id: number): string {
    return (
      this.departments.find((department) => department.id === id)
        ?.displayName || id.toString()
    );
  }

  getAllUsers() {
    this.userService.getUsers().subscribe((result) => {
      this.users = result;
    });
  }

  /**
   * Function which switches the list between courses and the course event log.
   */
  switchDataInList() {
    if (this.isHistory) {
      this.updateListWithDepartmentData();
      this.isHistory = false;
    } else {
      this.updateListWithLogData();
      this.isHistory = true;
    }
  }

  updateListWithLogData() {
    this.logHelper.updateLogList(
      LogType.Department,
      this.getDepartmentNameFromId.bind(this),
      (data) => (this.logListView.listData().listData = data),
      () => this.logListView.update()
    );
  }

  updateListWithDepartmentData() {
    this.DepartmentService.getDepartments().subscribe((result) => {
      let tempList: listRow<Department>[] = [];
      result.forEach((department) => {
        if (department.id != null && department.displayName != null) {
          tempList.push({
            object: department,
            id: department.id,
            data: [department.displayName],
          });
        }
      });
      this.departments = result;
      this.listView.listData().listData = tempList;
      this.listView.update();
    });
  }

  departmentClicked(department: Department) {
    let dialogref = this.dialog.open(DepartmentsDialogComponent, {
      data: { data: [department] },
    });
    dialogref.afterClosed().subscribe((result) => {
      if (result == true) {
        this.updateListWithDepartmentData();
      }
    });
  }
}
